module.exports = __webpack_public_path__ + "img/ELEC.c4da0017.svg";